import { render, staticRenderFns } from "./workStatistics.vue?vue&type=template&id=e5b89d96&"
import script from "./workStatistics.vue?vue&type=script&lang=js&"
export * from "./workStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports